module.exports = __webpack_public_path__ + "img/admin.51219ced.svg";